import { useState } from "react";
import { Modal } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import { CreateUpdateHoldingForm } from "modules/HoldingsDashboard/components/CreateUpdateHoldingModal/components";
import "modules/HoldingsDashboard/components/CreateUpdateHoldingModal/CreateUpdateHoldingModal.scss";
import { useCreateHoldingMutation, useUpdateHoldingMutation } from "modules/HoldingsDashboard/components/CreateUpdateHoldingModal/hooks";

import type { Holding } from "models";
import type { CreateHoldingPayload } from "modules/HoldingsDashboard/components/CreateUpdateHoldingModal/hooks";

type CreateUpdateHoldingModalProps = {
  isOpen: boolean;
  holding: Holding | null;
  onClose: () => void;
};

const FormHelper = createFormHelper<CreateHoldingPayload>();

export const CreateUpdateHoldingModal = ({ isOpen, onClose, holding }: CreateUpdateHoldingModalProps) => {
  const [hasErrors, setHasErrors] = useState(false);

  const { mutateAsync: updateHolding, isPending: isUpdateHoldingPending } = useUpdateHoldingMutation();
  const { mutateAsync: createHolding, isPending: isCreateHoldingPending } = useCreateHoldingMutation();

  const handleClose = () => {
    onClose();
    setHasErrors(false);
  };

  const isFormDataInvalid = (values: CreateHoldingPayload) => !values.name || !values.dealer_ids.length;

  const handleSubmit = async (values: CreateHoldingPayload) => {
    const hasErrors = isFormDataInvalid(values);
    setHasErrors(hasErrors);
    if (hasErrors) return;

    if (holding) await updateHolding(values);
    else await createHolding(values);

    handleClose();
  };

  return (
    <Modal open={isOpen} onClose={handleClose} closeOnDimmerClick={false} size="small">
      <div className="CreateUpdateHoldingModal">
        <FormHelper.Form onSubmit={handleSubmit} defaultValues={{ id: holding?.id ?? -1, name: holding?.name ?? "", dealer_ids: holding?.dealer_ids ?? [] }}>
          <CreateUpdateHoldingForm hasErrors={hasErrors} isPending={isCreateHoldingPending || isUpdateHoldingPending} onClose={handleClose} holding={holding} />
        </FormHelper.Form>
      </div>
    </Modal>
  );
};
